module.exports = __webpack_public_path__ + "img/weixin.cd6139b1.png";